<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 2147483646;">
  <div id="liveToast" class="toast fade" role="alert">
    <div class="toast-header">
      <strong class="me-auto">Notification</strong>
      <button type="button" class="btn-close" data-bs-dismiss="toast"></button>
    </div>
    <div class="toast-body">
      Message
    </div>
  </div>
</div>
